import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { AssetList } from "./AssetList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({ id: "finding.no_anti_heal", message: "No anti-heal against {hero}" });

const DETAILS = msg({
  id: "finding.no_anti_heal.details",
  message: "The enemy team healed {healing, number} this match, and you cut none of it.",
});

const SUMMARY = msg({
  id: "finding.no_anti_heal.summary",
  message: "Enemies healed {healing, number}",
});

const SUGGESTED = msg({
  id: "finding.suggested_items",
  message: "Strong players on your hero take:",
});

// Враги много лечились, а лечение не срезалось.
export const NoAntiHeal = ({ finding, variant }: FindingProps<"no_anti_heal">) => {
  const { i18n } = useLingui();
  const hero = useAssetLookup("heroes")(finding.params.healer_hero_id);
  const findItem = useAssetLookup("items");
  const healing = finding.params.enemy_healing;
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={hero} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { hero: hero.name } })}
      details={i18n._({ ...DETAILS, values: { healing } })}
      summary={i18n._({ ...SUMMARY, values: { healing } })}
    >
      <AssetList
        label={i18n._(SUGGESTED)}
        entries={finding.params.suggested_item_ids.map((id) => ({ asset: findItem(id) }))}
      />
    </FindingCard>
  );
};
